{
  "srTitle": "Anti Human Safari Project — dronebeskyttelse for civile i Kherson, Ukraine",
  "logoAlt": "Anti Human Safari Project-logo",
  "intro": "Vi leverer beskyttelsesudstyr mod angreb fra små droner til frivillige, beredskabstjenester og medarbejdere i kritisk infrastruktur i Kherson, Ukraine.",
  "safari": "Siden sommeren 2024 er civile i Kherson systematisk blevet jagtet af den russiske hær med videodroner i en terrorkampagne kendt som »Human Safari«.",
  "unLink": "FN-kommission anerkender Human Safari som en krigsforbrydelse",
  "donateNow": "Donér nu",
  "donateMonthly": "Donér månedligt",
  "otherWays": "andre måder at donere på",
  "instagram": "Instagram",
  "pastFundraisers": "Tidligere indsamlinger:",
  "fundraiser2025": "Indsamling 2025",
  "donateVia": "Donér via:",
  "charityRef": "via britisk velgørenhed, med referencen:",
  "germanCharityRef": "via tysk velgørenhed, med referencen:",
  "copy": "Kopiér",
  "copied": "Kopieret!",
  "close": "Luk",
  "viewMedia": "Se medie",
  "andrushenkoCredit": "Oleksandr Andrushenko, fotokorrespondent for mediet Vgoru",
  "fruitSellerDescription": "Frugtsælger jagtet af en fiberoptisk drone",
  "khersonPoliceCredit": "fra @khersonpolice",
  "firefighterDescription": "En brandmand slukker en bil efter et angreb i »Human Safari«; bagved ligger et offer",
  "previousMedia": "Forrige",
  "nextMedia": "Næste",
  "fpvDroneDescription": "FPV-drone på jagt under »Human Safari«",
  "busAttackDescription": "Et af mange FPV-droneangreb på offentlig transport",
  "notFoundTitle": "Siden blev ikke fundet",
  "notFoundMessage": "Den side findes ikke. Den er måske flyttet, eller linket er forkert.",
  "backHome": "Tilbage til forsiden",
  "droneDetectorDescription": "Dronedetektorer er små håndholdte enheder, der kan advare, hvis en drone er i nærheden",
  "vestDescription": "Lette beskyttelsesveste kan mindske alvoren af skader fra et droneangreb"
}
